import React, { memo, useState } from 'react';
import styles from './Score.module.less';
import classNames from 'classnames';
import { STAR_NUM } from '../Comment/config';

function ComtScore(props) {
  const {
    score = 0,
    onChange,
    size = 'lg',
    starLabels,
    style,
    editable = true,
    scoreLabels,
  } = props;
  const [hoverscore, setHoverScore] = useState(0);

  return (
    <div className={styles.ComtScore}>
      <div
        className="score-box"
        onMouseOut={() => {
          editable && setHoverScore(0);
        }}
      >
        {new Array(5).fill(0).map((el, idx) => {
          return (
            <div
              className={classNames(
                'star-icon',
                size === 'lg' ? 'star-lg' : 'star-sm',
                (idx + 1 <= score || idx + 1 <= hoverscore) && 'active',
              )}
              key={idx}
              onMouseOver={() => {
                editable && setHoverScore(idx + 1);
              }}
              style={style}
              onClick={() => {
                editable && onChange && onChange(idx + 1);
              }}
            />
          );
        })}
      </div>
      {starLabels && (hoverscore > 0 || score > 0) && (
        <span className="star-label">{starLabels[STAR_NUM[hoverscore || score]].name}</span>
      )}
      {scoreLabels && (hoverscore > 0 || score > 0) && (
        <span className="score-label">{scoreLabels[hoverscore || score]}</span>
      )}
    </div>
  );
}

export default memo(ComtScore);
